import { html, LitElement } from 'lit';
import { DebugService } from '../../../shared/services/debug.service.js';

class RefiPersonalReview extends LitElement {
  constructor() {
    super();
    this.debug = new DebugService('RefiPersonalReview');
  }

  static get properties() {
    return {
      firstName: { type: String, reflect: true },
      lastName: { type: String, reflect: true },
      dob: { type: String, reflect: true },
      lastFourSsn: { type: String },
      phoneNumber: { type: String },
      emailAddress: { type: String },
    };
  }

  render() {
    return html` <div>
      <fs-body-text id="checkout-name" variant="primary"
        >${this.firstName} ${this.lastName}</fs-body-text
      >
      <fs-body-text id="checkout-dob" variant="primary"
        >${this.maskDateOfBirth(this.dob)}</fs-body-text
      >
      <fs-body-text id="checkout-last-four-ssn" variant="primary"
        >${this.lastFourSsn ? `***-**-${this.lastFourSsn}` : ''}</fs-body-text
      >
      <fs-body-text id="checkout-phone" variant="primary"
        >${this.phoneNumber}</fs-body-text
      >
      <fs-body-text id="checkout-email" variant="primary"
        >${this.emailAddress}</fs-body-text
      >
    </div>`;
  }

  maskDateOfBirth(dateOfBirth) {
    if (dateOfBirth !== '' && dateOfBirth !== undefined) {
      return `${dateOfBirth.substring(0, 3)}**${dateOfBirth.substring(5)}`;
    }

    return '';
  }
}

customElements.define('refi-personal-review', RefiPersonalReview);
